export function tranformData(data) {
    const generateId = () => crypto.randomUUID();

    return {
        ...data,
        failed_data: {
            piece: data.failed_data.piece.map((item) => ({
                ...item,
                id: generateId(),
                isEditing: false,
                isPassing: false,
                barcode: null,
            })),
            bundle: data.failed_data.bundle.map((bundle) => ({
                ...bundle,
                id: generateId(),
                items: bundle.items.map((item) => ({
                    ...item,
                    id: generateId(),
                    barcode: null,
                    isEditing: false,
                    isPassing: false,
                })),
            })),
        },
    };
}
